"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var FetchError_1 = require("../FetchError");
var utils_1 = require("../utils");
var jsonHeaders = { 'Content-Type': 'application/json' };
var noop = function () { };
var toJson = function (response) { return response.json(); };
var defaultSearchCount = 25;
var TweekManagementClient = (function () {
    function TweekManagementClient(config) {
        this.config = config;
        this.config.baseServiceUrl = utils_1.normalizeBaseUrl(config.baseServiceUrl);
    }
    TweekManagementClient.prototype.getAllKeyManifests = function () {
        var url = this.config.baseServiceUrl + "/api/v2/manifests";
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getKeyManifest = function (path) {
        var url = this.config.baseServiceUrl + "/api/v2/manifests/" + path;
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getKeyDependents = function (path) {
        var url = this.config.baseServiceUrl + "/api/v2/dependents/" + path;
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getKeyDefinition = function (path, revision) {
        var queryParamsObject = { revision: revision };
        var queryString = utils_1.toQueryString(queryParamsObject);
        var url = this.config.baseServiceUrl + "/api/v2/keys/" + path + queryString;
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.saveKeyDefinition = function (path, keyDefinition) {
        var url = this.config.baseServiceUrl + "/api/v2/keys/" + path;
        var config = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(keyDefinition),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.deleteKey = function (path, aliases) {
        if (aliases === void 0) { aliases = []; }
        var url = this.config.baseServiceUrl + "/api/v2/keys/" + path;
        var config = {
            method: 'DELETE',
            headers: jsonHeaders,
            body: JSON.stringify(aliases),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.getKeyRevisionHistory = function (path, since) {
        if (since === void 0) { since = '1 month ago'; }
        var queryParamsObject = { since: since };
        var queryString = utils_1.toQueryString(queryParamsObject);
        var url = this.config.baseServiceUrl + "/api/v2/revision-history/" + path + queryString;
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getAllTags = function () {
        var url = this.config.baseServiceUrl + "/api/v2/tags";
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.appendTags = function (tags) {
        var url = this.config.baseServiceUrl + "/api/v2/tags";
        var config = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(tags),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.getSuggestions = function (query, count) {
        var queryParamsObject = {
            q: query,
            count: count || defaultSearchCount,
        };
        var queryString = utils_1.toQueryString(queryParamsObject);
        var url = this.config.baseServiceUrl + "/api/v2/suggestions" + queryString;
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.search = function (query, count) {
        var queryParamsObject = {
            q: query,
            count: count || defaultSearchCount,
        };
        var queryString = utils_1.toQueryString(queryParamsObject);
        var url = this.config.baseServiceUrl + "/api/v2/search" + queryString;
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getContext = function (identityType, identityId) {
        var url = this.config.baseServiceUrl + "/api/v2/context/" + identityType + "/" + encodeURIComponent(identityId);
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.appendContext = function (identityType, identityId, context) {
        var url = this.config.baseServiceUrl + "/api/v2/context/" + identityType + "/" + encodeURIComponent(identityId);
        var config = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify(context),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.deleteContextProperty = function (identityType, identityId, property) {
        var url = this.config.baseServiceUrl + "/api/v2/context/" + identityType + "/" + encodeURIComponent(identityId) + "/" + property;
        var config = { method: 'DELETE' };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.deleteContext = function (identityType, identityId) {
        var url = this.config.baseServiceUrl + "/api/v2/context/" + identityType + "/" + encodeURIComponent(identityId);
        var config = { method: 'DELETE' };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.getAllSchemas = function () {
        var url = this.config.baseServiceUrl + "/api/v2/schemas";
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.deleteIdentity = function (identityType) {
        var url = this.config.baseServiceUrl + "/api/v2/schemas/" + identityType;
        var config = { method: 'DELETE' };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.saveIdentity = function (identityType, schema) {
        var url = this.config.baseServiceUrl + "/api/v2/schemas/" + identityType;
        var config = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify(schema),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.patchIdentity = function (identityType, patch) {
        var url = this.config.baseServiceUrl + "/api/v2/schemas/" + identityType;
        var config = {
            method: 'PATCH',
            headers: jsonHeaders,
            body: JSON.stringify(patch),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.currentUser = function () {
        var url = this.config.baseServiceUrl + "/api/v2/current-user";
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getPolicies = function () {
        var url = this.config.baseServiceUrl + "/api/v2/policies";
        return this._fetch(url)
            .then(toJson)
            .then(function (x) { return x.policies; });
    };
    TweekManagementClient.prototype.getJWTExtractionPolicy = function () {
        var url = this.config.baseServiceUrl + "/api/v2/jwt-extraction-policy";
        return this._fetch(url)
            .then(toJson)
            .then(function (x) { return x.data; });
    };
    TweekManagementClient.prototype.saveJWTExtractionPolicy = function (jwtRegoPolicy) {
        var url = this.config.baseServiceUrl + "/api/v2/jwt-extraction-policy";
        var config = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify({ data: jwtRegoPolicy }),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.savePolicies = function (policies) {
        var url = this.config.baseServiceUrl + "/api/v2/policies";
        var config = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify({ policies: policies }),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.patchPolicies = function (patch) {
        var url = this.config.baseServiceUrl + "/api/v2/policies";
        var config = {
            method: 'PATCH',
            headers: jsonHeaders,
            body: JSON.stringify(patch),
        };
        return this._fetch(url, config).then(noop);
    };
    TweekManagementClient.prototype.getAuthProviders = function () {
        var url = this.config.baseServiceUrl + "/auth/providers";
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getServiceDetails = function () {
        var url = this.config.baseServiceUrl + "/version";
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.getHooks = function (keyPathFilter) {
        var url = this.config.baseServiceUrl + "/api/v2/hooks";
        if (keyPathFilter) {
            var queryParamsObject = { keyPathFilter: keyPathFilter };
            var queryString = utils_1.toQueryString(queryParamsObject);
            url += "/" + queryString;
        }
        return this._fetch(url).then(toJson);
    };
    TweekManagementClient.prototype.createHook = function (hookData) {
        var requestUrl = this.config.baseServiceUrl + "/api/v2/hooks";
        var config = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify(hookData),
        };
        return this._fetch(requestUrl, config).then(toJson);
    };
    TweekManagementClient.prototype.updateHook = function (_a) {
        var id = _a.id, hookData = __rest(_a, ["id"]);
        var requestUrl = this.config.baseServiceUrl + "/api/v2/hooks/" + id;
        var config = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(hookData),
        };
        return this._fetch(requestUrl, config).then(noop);
    };
    TweekManagementClient.prototype.deleteHook = function (_a) {
        var id = _a.id;
        var requestUrl = this.config.baseServiceUrl + "/api/v2/hooks/" + id;
        var config = { method: 'DELETE' };
        return this._fetch(requestUrl, config).then(noop);
    };
    TweekManagementClient.prototype._fetch = function (input, init) {
        return this.config.fetch(input, init).then(function (response) {
            if (!response.ok) {
                return Promise.reject(new FetchError_1.FetchError(response, 'tweek server responded with an error'));
            }
            return response;
        });
    };
    return TweekManagementClient;
}());
exports.default = TweekManagementClient;
//# sourceMappingURL=TweekManagementClient.js.map


// WEBPACK FOOTER //
// ../../src/TweekManagementClient/TweekManagementClient.ts